import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteSession, putMBMAVOBBox } from "services/ConfigServices";
import useSessionTable from "./useSessionTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { sessiontext } from "variables/MBM/session";
import { sessiontypeData } from "variables/MBM/lists/session";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import SessionDialog from "./SessionDialog.js";
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import CloudSyncIcon from '@mui/icons-material/CloudSync';

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;
const ExpandableSubElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;
const ElementSubTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  margin-left: 10px;
  font-family: "Source Sans Pro",sans-serif;
`;
const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 13px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const StatusDiv = styled.div`
width: 32px;
height: 32px;
font-weight: 400;
font-size: 12px;
font-family: "Source Sans Pro",sans-serif;
`;

const useStyles2 = makeStyles((theme) => ({
  StatusOKIcon: {
    color: "#91c241",
    fontSize: "31px"
  },
  StatusWarningIcon: {
    color: "#FF763",
    fontSize: "31px"
  },
  StatusUnknownIcon: {
    color: "#605f70",
    fontSize: "31px"
  },
  StatusDangerIcon: {
    color: "#f44336",
    fontSize: "31px"
  },
}));

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTSession = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype == 1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [currentSession, setCurrentSession] = useState(null);
  const { gridState, refetch, setSessions } = useSessionTable();

  let dataSession = gridState.data;

  const classes = useStyles();
  const classes2 = useStyles2();
  const columns = [
    {
      name: sessiontext.id,
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "5rem",
      cell: (row) => row.id,
    },
    {
      name: sessiontext.handlerid,
      selector: (row) => row.handlerguid,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.handlerguid,
    },
    {
      name: sessiontext.type,
      selector: (row) => sessiontypeData.find((x) => x.id == row.sessiontype)?.name || "",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => sessiontypeData.find((x) => x.id == row.sessiontype)?.name || ""
    },
    {
      name: sessiontext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: sessiontext.watchperiod,
      selector: (row) => row.watchperiod,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => row.watchperiod,
    },
    {
      name: sessiontext.group,
      selector: (row) => groupInfoListById["" + row.groupid] || "",
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: sessiontext.equipmentcount,
      selector: (row) => row.equipmentcount,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => row.equipmentcount,
    },
    {
      name: sessiontext.laststatustime,
      selector: (row) => row.lasthealthdate,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.laststatustime && moment(row.laststatustime).isValid()
          ? moment(row.laststatustime).format("DD/MM/YYYY HH:mm:ss")
          : "",
    },
    {
      name: sessiontext.laststatus,
      selector: (row) => (row.laststatustime && moment(row.laststatustime).isValid() && (moment(row.laststatustime) > moment().add(-4, 'h'))) ? row.laststatus : -1,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => <Tooltip title={sessiontext.laststatus}><StatusDiv>
        {
          row.laststatustime && moment(row.laststatustime).isValid() && (moment(row.laststatustime) > moment().add(-4, 'h')) ?
            (row.laststatus == 1 ?
              <CheckCircleOutlineIcon className={classes2.StatusOKIcon} fontSize="large" color="success" /> :
              row.laststatus == 0 ?
                <CrisisAlertIcon className={classes2.StatusDangerIcon} fontSize="large" color="error" /> : <></>)
            :
            <QuestionMarkIcon className={classes2.StatusUnknownIcon} fontSize="large" color="disabled" />
        }
      </StatusDiv></Tooltip>,
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {mbm_admin && (
              <>
                <Tooltip title={sessiontext.sessionedition}>
                  <Button
                    onClick={editSession(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title={sessiontext.sessiondel}>
                  <CustomDeleteButton
                    deleteTitle={sessiontext.sessiondel}
                    deleteSubTitle={sessiontext.sessiondelconfirm +' '+row.name+'?'}
                    handleSupprimer={deleteSessionFunction(row)}
                  />
                </Tooltip></>
            )}
          </div>
        </>
      ),
    },
  ];

  const ExpandableComponent = props => {
    const { data } = props;
    const SubTabs = () => {
      return (
        <>
          <div>
            <ExpandableContainer>
              <ElementSubTitle>{sessiontext.sessionurl}</ElementSubTitle>
              <ElementData>{data.sessionurl}</ElementData>
              <ElementSubTitle>{sessiontext.rooturl}</ElementSubTitle>
              <ElementData>{data.rootobjecturl}</ElementData>
            </ExpandableContainer>
          </div>

        </>
      );
    };
    return (
      <Container>
        <ExpandableContainer>
          <div>
            <SubTabs />
          </div>
        </ExpandableContainer>
      </Container>
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editSession = (row) => async () => {
    let obj = dataSession.find((o) => o.id === row.id);
    if (obj) {
      setCurrentSession(obj);
      handleClickOpen();
    }
  }

  const deleteSessionFunction = (row) => async () => {
    let obj = dataSession.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteSession(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            sessiontext.sessiondelok
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSessions(selection.selectedRows);
  };


  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>{sessiontext.nosession}</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandOnRowClicked
        expandableRows={mbm_admin}
        expandableRowsComponent={ExpandableComponent}
        expandableRowDisabled={(row) => row.disabled}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          {sessiontext.sessionedition}
        </CustomDialogTitle>
        <DialogContent dividers>
          <SessionDialog
            currentSession={currentSession}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTSession;
